<template>
<v-container id="dashboard" fluid tag="section">
     <v-container fluid fill-height>
        <v-layout align-center justify-center>
        </v-layout>
    </v-container>
</v-container>
</template>

 
<script>

import Vue from 'vue'
import moment from "moment";
import axios from "axios";

export default {
  beforeMount: function() {
    var self = this;
       
   

   let url_origen = document.referrer;
 
    window.localStorage.clear();
    Vue.prototype.$user.set({ role: "guest" });
    Vue.prototype.$user.set({ id_cliente: "0" });
    if(url_origen == "https://login.econnectpro.mx/"){
        
        self.validaMail();
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    }
    else{
         var msg = "Ocurrió un error al verificar el usuario";
            self.$swal({
                type: "error",
                title: msg,
                text: "",
                footer: "Operación no permitida"
            });
    }
  },
  methods: {
        validaMail() {
            var url = this.$hostname + "usuarios/verifica_email/";
            var datos = {
                email: this.$route.params.id,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };
            var self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(url, datos)
                .then(function (response) {

                    self.isEmailValido = true;
                    self.model.email = self.$route.params.id;
                    self.login();

                })
                .catch(function (error) {
                    console.log(error);
                    var msg = "Ocurrió un error al verificar el usuario";

                    if (error.response) {
                        if (error.response.data.mensaje) {
                            msg = error.response.data.mensaje;
                        } else {
                            if (error.response.data.email != null)
                                msg = error.response.data.email[0];
                        }
                    }
                    self.$swal({
                        type: "error",
                        title: msg,
                        text: "",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
            // this.$router.push('/pass');
        },
        signalChange: function (evt) {
            this.$emit("change", evt);
            this.isEmailValido = false;
        },
     
        login: async function () {
            try {
                var data = {
                    username: this.model.email,
                    password: "0j3FTsVvEyxXFYM8hp3FDiB8PR",
                    sistema: this.$sistema,
                };

                var url = this.$hostname + "usuarios/login/";
                var self = this;
                self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                await axios
                    .post(url, data)
                    .then(function (response) {
                        if (response.data.mensaje != null) {
                            self.respuestalogin = response.data.mensaje;
                            var tipoUsuario = response.data.mensaje.tipo_usuario;
                           
                            self.iniciar();
                            
                        } else {
                            self.$root.$dialogLoader.hide();
                        }
                    })
                    .catch(function (error) {
                        self.$root.$dialogLoader.hide();
                        var msg = "";
                        //console.log(error);
                        if (error.response != null) {
                            if (error.response.data.mensaje) {
                                msg = error.response.data.mensaje;
                            } else {
                                if (error.response.data.email)
                                    msg += error.response.data.email[0];
                                if (error.response.data.password)
                                    msg += error.response.data.password[0];
                            }
                        } else {
                            msg = 'Ocurrió un error al iniciar sesión. Favor de comunicarse con soporte.';
                        }

                        if (error.response.status == 406) { //Ocurrió una excepción y hay que dejar al usuario con sesionactiva=0
                            var urlLogout = self.$hostname + "usuarios/logout_by_mail/";
                            axios.post(urlLogout, {
                                    usuario: self.model.email
                                })
                                .then(function (response) {}).catch(function (error) {}).then(() => {
                                    self.$local_storage.set("token", "");
                                    self.$local_storage.set("id_usuario", 0);
                                    self.$local_storage.set("tipo_usuario", "guest");
                                    self.$user.set({
                                        role: "guest"
                                    });
                                    self.$user.set({
                                        id_cliente: 0
                                    });
                                });
                        }

                        self.$swal({
                            type: "error",
                            title: "Operación No Permitida",
                            text: msg,
                            footer: ""
                        });
                    });
            } catch (error) {
                this.$swal({
                    type: "error",
                    title: "Operación No Permitida",
                    text: 'Ocurrió un error al iniciar sesión. Favor de intentar nuevamente',
                    footer: ""
                });
            }

        },
        inicializapermisos: async function (estatus) {
            //  var result = [];
            var data = {
                sistema: this.$sistema,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };

            var url = this.$hostname + "sistemas/get_permisos_sistema/";
            let self = this;
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        self.$local_storage.set(element.clave, estatus);
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        permisoscliente: async function (id_cliente) {
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: 0,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
           
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        self.$local_storage.set(element.clave, 100);
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            for (var i = 1; i < 19; i++) {
                self.$local_storage.set("Modulo" + i, 0);
            }

            data = {
                cliente: id_cliente
            }
            axios
                .post(self.$hostname + "clientes-sistemas/list_modulos_cliente/", data)
                .then(response => {
                    response.data.forEach(function (m) {
                        self.$local_storage.set("Modulo" + m.modulo, 100);
                    });
                    if (response.data.length == 1 && self.$local_storage.get("Modulo13") == 100) {
                        self.$local_storage.set("soloCartaPorte", 100);
                        this.mostrarmenu(true);
                    } else {
                        self.$local_storage.set("soloCartaPorte", 0);
                    }

                    

                    if (response.data.length == 1 && self.$local_storage.get("Modulo15") == 100) {
                        self.$local_storage.set("soloSA31", 100);
                        self.$store.state.sa31 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 1 && self.$local_storage.get("Modulo16") == 100) {
                        self.$local_storage.set("soloSA31", 100);
                        self.$store.state.sa31 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 1 && self.$local_storage.get("Modulo18") == 100) {
                        self.$local_storage.set("soloSA24", 100);
                        self.$store.state.sa24 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 2 && self.$local_storage.get("Modulo15") == 100 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    this.mostrarmenu(true);
                     } 
                    
                    
                })
                .catch(error => {
                    console.log(error);
                });
        },
        permisosgrupo: async function (id_perfil) {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                id_perfil: id_perfil,
                cliente: 0,
                sistema: 1
            }
            await axios
                .post(this.$hostname + "perfiles/get_permisos_perfil/", data)
                .then(response => {

                    var arr = response.data;
                    console.log("paso6");
                    for (var i in arr) {
                        if (arr[i].activo == 1) {
                            let clave = arr[i].clave;
                            self.$local_storage.set(clave, 100);
                        }

                    }

                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los permisos.",
                        footer: ""
                    });
                });
        },

        permisosusuario: async function (id_cliente, perfil) {
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: 0,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
            let permisos_cliente = [];
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        permisos_cliente.push(element.clave);
                    });
                    console.log(perfil);
                    // carga los permisos del usaurio
                    perfil.forEach(function (element) {
                        if (permisos_cliente.includes(element.clave))
                            self.$local_storage.set(element.clave, "100");
                    });
                    for (var i = 1; i < 19; i++) {
                            self.$local_storage.set("Modulo" + i, 0);
                        }
                        console.log(self.respuestalogin);
                        data = {
                            perfil: self.respuestalogin.perfil_grupo
                        }
                        axios
                            .post(self.$hostname + "perfiles/get_modulos_perfil/", data)
                            .then(response => {
                                console.log(response.data);
                                response.data.forEach(function (m) {

                                    self.$local_storage.set("Modulo" + m.id_modulo, 0);
                                    if(m.acceso == 1)
                                        self.$local_storage.set("Modulo" + m.id_modulo, 100);

                                });
                                response.data = response.data.filter(i => i.acceso == 1 );

                                if (response.data.length == 1 && self.$local_storage.get("Modulo13") == 100) {
                                    self.$local_storage.set("soloCartaPorte", 100);
                                    self.mostrarmenu(true);
                                } else {
                                    self.$local_storage.set("soloCartaPorte", 0);
                                    self.mostrarmenu(true);
                                }

                                

                                if (response.data.length == 1 && self.$local_storage.get("Modulo15") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 1 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 1 && self.$local_storage.get("Modulo18") == 100) {
                                    self.$local_storage.set("soloSA24", 100);
                                    self.$store.state.sa24 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 2 && self.$local_storage.get("Modulo15") == 100 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                               
                                
                                
                            })
                            .catch(error => {
                                console.log(error);
                            });

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
 verAvisos: function (id_usuario, tipoUsuario) {
            try {
                axios
                    .post(this.$hostname + "notificaciones/list_notificaciones/", {
                        usuario: id_usuario
                    })
                    .then(response => {
                        let notificaciones = response.data.filter(notificacion => {
                            if (notificacion.mostrar_aviso != undefined) {
                                return notificacion.mostrar_aviso == 1 && notificacion.estatus == 0;
                            }
                        });

                        for (var k in notificaciones) {
                            let item = notificaciones[k];
                            var mensaje = item.mensaje;
                            var footer = "";
                            var fileadjunto = "";
                            try {
                                var json = JSON.parse(mensaje);
                                if (json.texto != undefined)
                                    mensaje = json.texto;
                                if (json.file != undefined && json.file != "") {
                                    footer = 'Ver archivo adjunto';
                                    fileadjunto = json.file;
                                }
                            } catch (e) {}

                            //Si son varias notificaciones o tiene archivo le damos la opcion de enviarloa  notificaciones o descargar file
                            if (notificaciones.length > 1) {

                                footer = 'Ver ' + notificaciones.length + ' notificaciones más'
                                footer =  ""
                                if (item.tipo != 'IMAGEN') {
                                    this.$swal({
                                        type: "info",
                                        title: item.titulo,
                                        text: mensaje,
                                        footer: "",
                                        confirmButtonColor: "#1B5E20",
                                        confirmButtonText: "Aceptar"
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                        if (result.value) {
                                          //  this.$router.push('/notificaciones').catch(() => {});
                                         // this.verAvisos (id_usuario, tipoUsuario);
                                        }
                                    
                                });
                            
                                } else {
                                            this.$swal({
                                                "width": "80em",
                                                "confirmButtonText": "Aceptar",
                                                "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/' + fileadjunto + '"  style="max-width:100%" />'
                                            }).then(result => {
                                                this.markRead(item, id_usuario, tipoUsuario);
                                                if (result.value) {
                                                    //  this.$router.push('/notificaciones').catch(() => {});
                                                  //  this.verAvisos (id_usuario, tipoUsuario);
                                                }
                                            });
                                        }
                            } else if (footer != "" && fileadjunto != "") {
                                if (item.tipo != 'IMAGEN') {
                                    this.$swal({
                                        type: "info",
                                        title: item.titulo,
                                        text: mensaje,
                                        footer: "",
                                        confirmButtonColor: "#1B5E20",
                                        confirmButtonText: "Aceptar"
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                       // if (result.value) {
                                         //   this.downloadFile(fileadjunto);
                                       // }
                                    });
                                } else {
                                    this.$swal({
                                        "width": "80em",
                                        "confirmButtonText": "Aceptar",
                                        "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/' + fileadjunto + '"  style="max-width:100%" />'
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);

                                    });
                                }
                            } else { //Si es solo una notificacion se muestra normal
                                this.$swal({
                                    type: "info",
                                    title: item.titulo,
                                    text: mensaje,
                                    footer: "",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "Aceptar",
                                }).then(result => {
                                    if (result.value) {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                    }
                                });
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            } catch (error) {
                console.log(error);
            }

        },
        iniciar: async function () {

            var self = this;
            var cliente = self.respuestalogin.cliente;
            self.$local_storage.set("subtipo_usuario", "");
            self.$local_storage.set("referencia_usuario", "");
            self.$local_storage.set("consignatario_usuario", "");
            self.$local_storage.set("trafico", 0);
            self.$local_storage.set("costing", 0);
            self.$local_storage.set('emanifiesto', 0);
            self.$local_storage.set('carta_porte', 0);
            self.$local_storage.set('verSA31',0);
            self.$local_storage.set('verSA24',0);
            self.$local_storage.set("es_transportista", 0);
            self.$local_storage.set("es_agente", 0);
            self.$local_storage.set("id_grupo", 0);
            self.$local_storage.set("soloSA31", 0);
            self.$local_storage.set("soloSA24", 0);
            self.$local_storage.set('sa31', 0);
            self.$local_storage.set('sa24', 0);
            self.$local_storage.set("soloCartaPorte", 0);

            var data = {
                email: self.respuestalogin.username,
            };
            await axios
                .post(self.$hostname + "avatar/get_avatar/", data)
                .then(res => {
                    if (typeof res.data !== "false") {
                        self.$local_storage.set("avatar", res.data.avatar);
                    }
                })
                .catch(err => {
                    // console.log(err);
                    self.$local_storage.set("avatar", "undefined");
                });

            if (cliente.id_cliente > 0) {
                self.$local_storage.set("rfc", cliente.rfc);
                self.$local_storage.set("id_cliente", cliente.id_cliente);
                self.$local_storage.set("dias_cliente", cliente.dias_cliente);
                self.$user.set({
                    id_cliente: cliente.id_cliente
                });
                self.$local_storage.set("razon", cliente.razon_social);
                self.$local_storage.set("varios_clientes", 0);
                self.$store.state.id_cliente = cliente.id_cliente;

                if (self.respuestalogin.subtipo_usuario != null)
                    self.$local_storage.set("subtipo_usuario", self.respuestalogin.subtipo_usuario);

                if (self.respuestalogin.referencia_usuario != null && self.respuestalogin.subtipo_usuario == "clientes_referencias")
                    self.$local_storage.set("referencia_usuario", self.respuestalogin.referencia_usuario);

            }
            self.$user.set({
                role: self.respuestalogin.tipo_usuario
            });

            self.$local_storage.set("panel_grupo", 0);
            self.$local_storage.set("token", self.respuestalogin.token);
            self.$local_storage.set("id_usuario", self.respuestalogin.id);

            if (self.respuestalogin.grupo == null)
                self.$local_storage.set("id_grupo", 0);
            else
                self.$local_storage.set("id_grupo", self.respuestalogin.grupo);

            self.$local_storage.set("tipo_usuario", self.respuestalogin.tipo_usuario);
            self.$local_storage.set("nombre_usuario", self.respuestalogin.nombre);
            self.$local_storage.set("email", self.respuestalogin.username);
            self.$local_storage.set("id_perfil", 0);
            self.$local_storage.set("perfil_grupo", 0);

            if (self.respuestalogin.grupo > 0)
                await self.getGrupo(self.respuestalogin.grupo);

            await self.verAvisos(self.respuestalogin.id, self.respuestalogin.tipo_usuario);
            await self.getTigies();

            await self.inicializapermisos("0");

            if (cliente.id_cliente > 0) {
                if (self.respuestalogin.perfil.length > 0) {
                    self.$local_storage.set("id_perfil", 1);
                    await self.permisosusuario(cliente.id_cliente, self.respuestalogin.perfil);
                } else {
                    self.$local_storage.set("id_perfil", 0);
                    await self.permisoscliente(cliente.id_cliente);
                }
                self.$local_storage.set("perfil_grupo", self.respuestalogin.perfil_grupo);

                if (self.$local_storage.get("soloCartaPorte") == 100)
                    self.$router.replace("/index").catch(() => {});

                if (self.$local_storage.get("soloSA31") == 100)
                    self.$router.replace("/indexsa31").catch(() => {});
               
                if (self.$local_storage.get("soloSA24") == 100)
                    self.$router.replace("/indexsa24").catch(() => {});

                if (self.$local_storage.get("Modulo14") == 100)
                    self.$router.replace("/indexAAC").catch(() => {});

                if (self.$local_storage.get("Modulo18") == 100 && (self.$local_storage.get("Modulo17") == 100 || self.$local_storage.get("Modulo16") == 100) && self.$local_storage.get("Modulo6") != 100  )
                    self.$router.replace("/vacio").catch(() => {});

                //cuando sea consignatario trafico/reporte_embarques
                if (self.respuestalogin.perfil_grupo == 43) {
                    self.$router.replace("/trafico/reporte_embarques").catch(() => {});
                    await self.mostrarmenu(true);
                } else {

                    //si solo tiene ds mandarlo a bitacora
                    if (self.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100 &&
                        self.$local_storage.get("VUCEM.Pedimento.consulta.cove") == 100) {
                        self.$router.replace("/home").catch(() => {});
                    } else {
                        if (self.$local_storage.get("DATA.STAGE.cargazip") == 100)
                            self.$router.replace("/datastage/bitacorazip").catch(() => {});
                        else if (self.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                            self.$router.replace("/transmision/covedetalles").catch(() => {});
                        else if (self.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                            self.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});
                    }
                    self.mostrarmenu(true);
                }


            } else {
                self.$local_storage.set("rfc", "");
                self.$local_storage.set("razon", "");
                self.$local_storage.set("id_cliente", 0);
                self.$local_storage.set("dias_cliente", "");
                self.$local_storage.set("perfil_grupo", 0);
                self.$local_storage.set("subtipo_usuario", "");
                self.$local_storage.set("referencia_usuario", "");
                self.$local_storage.set("carta_porte", 0);
                self.$local_storage.set("grupo", self.respuestalogin.grupo);

                if (self.respuestalogin.grupo == null)
                    self.$local_storage.set("id_grupo", 0);
                else
                    self.$local_storage.set("id_grupo", self.respuestalogin.grupo);

                self.$user.set({
                    id_cliente: 0
                });

                if (cliente == -1) self.$local_storage.set("varios_clientes", 1);

                if (self.respuestalogin.tipo_usuario == "Pagos" || self.respuestalogin.tipo_usuario == "Asuntos Legales") {
                    self.$local_storage.set("varios_clientes", 0);
                    self.$router.replace("/index").catch(() => {});
                }
                if ((self.respuestalogin.tipo_usuario == "Grupo") || self.respuestalogin.tipo_usuario == "Soporte" || cliente == -1) {

                    if (self.respuestalogin.perfil_grupo != null) {
                        self.$local_storage.set("perfil_grupo", self.respuestalogin.perfil_grupo);
                        await self.permisosgrupo(self.respuestalogin.perfil_grupo);

                    }

                    self.$local_storage.set("varios_clientes", 1);

                    if (self.$local_storage.get("panel_grupo") == 1)
                        this.$router.replace("/admin").catch(() => {});
                    else if (self.$local_storage.get("es_transportista") == 1)
                        self.$router.replace("/indext").catch(() => {});
                    else if (self.$local_storage.get("es_agente") == 1)
                        this.$router.replace("/indexAA").catch(() => {});
                    else if (self.manifiesto == 1) //Cuando un grupo no transportista entra por el login de emanifiesto (https://econnectpro.mx/?emanifiesto)
                        self.$router.replace("/indext").catch(() => {});
                    else if (self.$local_storage.get("soloSA31") == 100)
                        self.$router.replace("/indexsa31").catch(() => {});
                    else if (self.$local_storage.get("soloSA24") == 100)
                        self.$router.replace("/indexsa24").catch(() => {});
                    else
                        self.$router.replace("/listaclientes").catch(() => {});
                }

                if (self.respuestalogin.tipo_usuario == "Super Usuario") {
                    await self.inicializapermisos("100");
                    self.$store.state.id_cliente = -1;
                    self.$local_storage.set("varios_clientes", 1);
                    self.$router.replace("/admin").catch(() => {});
                }
                self.mostrarmenu(true);

                self.getMarquees();

            }
            self.$root.$dialogLoader.hide();
        },

        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },
        ver() {
            this.$swal({
                "width": "50em",
                "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/notificaciones/0.8843191653987947_2023 Linea de Captura.png"  style="max-width:500px" />'
            });
        },
      
      
        getMarquees: function () {
            axios
                .get(this.$hostname + "catalogos/notificaciones_marquee/")
                .then(response => {
                    let avisos = response.data.filter(aviso => aviso.activo == 1 && aviso.tipo == 1);
                    let texto = "";

                    for (let i = 0; i < avisos.length; i++)
                        this.$toast.info(avisos[i].texto, "", {
                            balloon: true,
                            close: true,
                            position: "bottomLeft",
                            timeout: null,
                            animateInside: true,
                            drag: true,
                            transitionIn: 'flipInX',
                            transitionOut: 'flipOutX',
                            pauseOnHover: true
                        })
                })
                .catch(error => {
                    console.log("Ocurrió un error al obtener los avisos.");
                });
        },
        getTigies: function () {
            var f = new Date();

            let y = f.getFullYear();
            let m = f.getMonth() + 1;
            let d = f.getDate();

            if (m < 10)
                m = '0' + m;
            else
                m='' + m;

            if (d < 10)
                d = '0' + d;
            else
                d= '' + d

            let hoy = y + '/' + m + '/' + d;

            let self = this; 
          //  fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + hoy + "'%20and%20'" + hoy + "'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
            fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + hoy + "'%20and%20'" + hoy + "'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
        //  fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'2024/08/28'%20and%20'2024/08/28'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
      
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    
                  //  if(Array.isArray(data)){
                        if(data['error'] != "undefined"){
                        console.log(Array.isArray(data));
                        data.forEach(function (p) {
                            
                        let fecha = self.arreglaMes(p.Fecha.substring(0, p.Fecha.length - 8));
                        let link = "<a target='_blank' title='Visualizar PDF' href='https://hts.gsmartcode.com/docs/bitacora/" + p.SYSID + ".pdf'> <i class='v-icon notranslate mdi mdi-file' /></a>";
                        let mas = "<br/><a href='/DOF'>Ver Mas..</a>"
                        if (p.Publicacion != "Sin publicación en el DOF el dia hoy, relacionada con la TIGIE."){
                            self.$toast.info(p.Publicacion + mas, "DOF - " + fecha + " - Secretaría " + p.Secretaria + link, {
                                balloon: true,
                                close: true,
                                position: "bottomLeft",
                                timeout: 10000,
                                animateInside: true,
                                drag: true,
                                transitionIn: 'flipInX',
                                transitionOut: 'flipOutX',
                                pauseOnHover: true
                            });
                            
                        }
                    });
                }

                }).catch(function (error) {
                    console.log(error);
                });

        },
        arreglaMes(mes) {
            let r = "";
            r = mes.replace('Jan', 'Ene');
            r = r.replace('Apr', 'Abr');
            r = r.replace('Aug', 'Ago');
            r = r.replace('Dec', 'Dic');

            return r;
        },
      
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getGrupo: async function (id_grupo) {
            var self = this;
            await axios
                .get(this.$hostname + "grupos/" + id_grupo + "/")
                .then(response => {
                    self.$local_storage.set("panel_grupo", response.data.panel);
                    self.$local_storage.set("es_transportista", response.data.es_transportista);
                    self.$local_storage.set("es_agente", response.data.es_agente);
                    self.$local_storage.set("rfc_grupo", response.data.rfc);
                    self.$local_storage.set("nombre_grupo", response.data.nombre);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        logout() {
            this.modal = false;
            var data = {
                usuario: this.respuestalogin.id,
                sistema: this.$sistema
            };

            var url = this.$hostname + "usuarios/logout/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    self.$local_storage.set("token", "");
                    self.$local_storage.set("id_usuario", 0);
                    self.$local_storage.set("cambio_cliente", true);
                    self.$user.set({
                        role: "guest"
                    });
                    self.$router.push("/").catch(() => {});
                    self.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "La sesión se cerró correctamente",
                        footer: '',
                    });
                })
                .catch(function (error) {

                    self.$swal({
                        type: "error",
                        title: "Operación no Permitida",
                        text: "Ocurrió un error al cerrar la sesión",
                        footer: ""
                    });
                });
        }
    },
  data: () => ({ 
     url: "",
     url_origen: "",
        label_user:"Ingrese su correo electrónico",
        verImagen: false,
        fab: false,
        fondo: "",
        manifiesto: 0,
        sa31: 0,
        sa24: 0,
        terminos: "",
        colortema: false,
        id_termino: 0,
        title: "",
        modal: false,
        respuestalogin: false,
        loading: false,
        loadingReset: false,
        loadingPdfTerminos: false,
        loadingPdfTerminosEnglish: false,
        isEmailValido: false,
        url: "",
        model: {
            email: "",
            password: ""
        }
   
  })
}


  </script>